import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from "../api.js";
import { toast } from 'react-toastify';

export const GetVendorCitySlice = createAsyncThunk("admin/vendor-city-list",async (params, { rejectWithValue }) => {
    try {
      const response = await api.GetVendorCityApi(params);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const GetVendorCityListDropDownSlice = createAsyncThunk("admin/vendor-city-listing",async (_, { rejectWithValue }) => {
    try {
      const response = await api.GetVendorCityListForDropDownApi();
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const AddVendorCitySlice = createAsyncThunk("admin/vendor-city-insert",async (data, { rejectWithValue }) => {
    try {
      const response = await api.AddVendorCityApi(data);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const UpdateVendorCitySlice = createAsyncThunk("admin/vendor-city-update/?id",async (data, { rejectWithValue }) => {
    try {
      const response = await api.UpdateVendorCityApi(data);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const DeleteVendorCitySlice = createAsyncThunk("admin/vendor-city-delete/id",async (id, { rejectWithValue }) => {
    try {
      const response = await api.DeleteVendorCityApi(id);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const VendorCityManagementSlice = createSlice({
  name: 'VendorCityManagement',
  initialState: {
    VendorCityList: [],
    CityListDropDown: [],
    AddVendorCity: [],
    UpdatedVendorCity: [],
    DeletedVendorCity: [],
    loading: false,
    error: null,
    validationErrors: [],
  },
  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null;
      state.validationErrors = [];
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || [];
    }

    builder
      .addCase(GetVendorCitySlice.pending,handlePendingState)
      .addCase(GetVendorCitySlice.fulfilled, (state, action) => {
        state.VendorCityList = action.payload.data;
        state.loading = false;
      })
      .addCase(GetVendorCitySlice.rejected,handleRejectState)

      .addCase(GetVendorCityListDropDownSlice.pending,handlePendingState)
      .addCase(GetVendorCityListDropDownSlice.fulfilled, (state, action) => {
        state.CityListDropDown = action.payload.data;
        state.loading = false;
      })
      .addCase(GetVendorCityListDropDownSlice.rejected,handleRejectState)

      .addCase(AddVendorCitySlice.pending,handlePendingState)
      .addCase(AddVendorCitySlice.fulfilled, (state, action) => {
        state.AddVendorCity = action.payload.data;
        state.loading = false;
        toast.success("Vendor City is created successfully!");
      })
      .addCase(AddVendorCitySlice.rejected,handleRejectState)

      .addCase(UpdateVendorCitySlice.pending,handlePendingState)
      .addCase(UpdateVendorCitySlice.fulfilled, (state, action) => {
        state.UpdatedVendorCity = action.payload.data;
        state.loading = false;
        toast.success("Vendor City is updated successfully!");
      })
      .addCase(UpdateVendorCitySlice.rejected,handleRejectState)

      .addCase(DeleteVendorCitySlice.pending,handlePendingState)
      .addCase(DeleteVendorCitySlice.fulfilled, (state, action) => {
        state.DeletedVendorCity = action.payload.data;
        state.loading = false;
        toast.success("Vendor City is deleted successfully!");
      })
      .addCase(DeleteVendorCitySlice.rejected,handleRejectState);
  },
});

export default VendorCityManagementSlice.reducer;
